export default "__VITE_ASSET__e7c367bc__"